import { c as _c } from "react/compiler-runtime";
import { Box, type BoxProps, Typography } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { MAXIMUM_COLUMNS_DESKTOP, MAXIMUM_COLUMNS_MOBILE } from '../ColumnContext';
type DetailBoxProps = {
  index: number;
  title: string;
  icon?: {
    name: string;
    dataTestId?: string;
  };
  containerProps?: BoxProps;
  contentContainerProps?: BoxProps;
};
export function DetailBox(t0) {
  const $ = _c(29);
  const {
    index,
    title,
    icon,
    children,
    containerProps,
    contentContainerProps
  } = t0;
  const firstColumn = index === 0;
  const lastColumnDesktop = index === MAXIMUM_COLUMNS_DESKTOP - 1;
  const lastColumnMobile = index === MAXIMUM_COLUMNS_MOBILE - 1;
  const iconClass = icon?.name;
  const t1 = firstColumn ? 3 : 0;
  const t2 = lastColumnMobile ? 3 : 0;
  const t3 = lastColumnDesktop ? 3 : 0;
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = {
      xs: t2,
      md: t3
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = index > MAXIMUM_COLUMNS_MOBILE - 1 ? "none" : "flex";
  let t6;
  if ($[3] !== t5) {
    t6 = {
      md: "flex",
      xs: t5
    };
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = `cc-compare-table-column-${index}`;
  const t8 = firstColumn ? 3 : 0;
  let t9;
  if ($[5] !== firstColumn || $[6] !== icon || $[7] !== iconClass || $[8] !== title) {
    t9 = firstColumn && <Box position="absolute" display="flex" flexDirection="row" alignItems="center">{icon && <Box component="span" aria-hidden="true" data-testid={icon.dataTestId} className={`mask-icon mask-icon-${iconClass}`} sx={{
        width: {
          xs: "1rem",
          md: "1.25rem"
        },
        height: {
          xs: "1rem",
          md: "1.25rem"
        },
        marginRight: "0.5rem",
        backgroundColor: "#008254"
      }} />}<Typography fontSize={{
        xs: "0.9rem",
        md: "1rem"
      }} fontWeight={700} lineHeight="1.5rem" color="primary.main" data-testid="cc-compare-table-row-name">{title}</Typography></Box>;
    $[5] = firstColumn;
    $[6] = icon;
    $[7] = iconClass;
    $[8] = title;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t8 || $[11] !== t9) {
    t10 = <Box pl={t8} py="0.5rem" sx={_temp} minHeight="calc(1.5rem + 0.5rem * 2 + 3px)">{t9}</Box>;
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== firstColumn || $[14] !== lastColumnDesktop || $[15] !== lastColumnMobile) {
    t11 = theme_0 => ({
      borderBottomLeftRadius: firstColumn ? "10px" : 0,
      borderBottomRightRadius: {
        xs: lastColumnMobile ? "10px" : 0,
        md: lastColumnDesktop ? "10px" : 0
      },
      borderBottom: `1px solid ${theme_0.palette.neutral.lighter}`,
      borderRight: `1px solid ${theme_0.palette.neutral.lighter}`,
      borderLeft: firstColumn ? `1px solid ${theme_0.palette.neutral.lighter}` : 0
    });
    $[13] = firstColumn;
    $[14] = lastColumnDesktop;
    $[15] = lastColumnMobile;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== children || $[18] !== contentContainerProps || $[19] !== t11) {
    t12 = <Box py={3} flexGrow={1} px={3} display="flex" flexDirection="column" gap={2} letterSpacing={0.8} sx={t11} {...contentContainerProps}>{children}</Box>;
    $[17] = children;
    $[18] = contentContainerProps;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== containerProps || $[22] !== t1 || $[23] !== t10 || $[24] !== t12 || $[25] !== t4 || $[26] !== t6 || $[27] !== t7) {
    t13 = <Box py={2} ml={t1} mr={t4} display={t6} flexDirection="column" data-testid={t7} {...containerProps}>{t10}{t12}</Box>;
    $[21] = containerProps;
    $[22] = t1;
    $[23] = t10;
    $[24] = t12;
    $[25] = t4;
    $[26] = t6;
    $[27] = t7;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}
function _temp(theme) {
  return {
    borderBottom: `3px solid ${theme.palette.primary.main}`
  };
}